import { Amplify } from 'aws-amplify';
import aws_config from '../../modified_aws-export';
import React, { useCallback, useEffect, useState } from "react";
import { PageBody, PageHeader, PageLayout } from "../../components";
import { useTranslation } from "react-i18next";
import "./ImageVectorizationPage.scss";
import { ImageVectorizationFilter } from "../../features/PopoverFilters/ImageVectorizationFilter";
import { IVectorizationDataModel } from "../../types/vectorization";
import { fetchVectorizationBatches } from "../../services/vectorization/loadImagesByBatch";
import EmptyState from "../../components/EmptyState/EmptyState";
import VectorizationBatch from "../../features/VectorizationBatch/VectorizationBatch";

Amplify.configure(aws_config);

const ImageVectorizationPage: React.FC = () => {
    const { t } = useTranslation();
    const [vectorizationBatchImages, setVectorizationBatchImages] = useState<Record<string, IVectorizationDataModel[]> | null>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [createdBy, setCreatedBy] = useState<string>("");
    const [noItems, setNoItems] = useState(50);
    const [isSeeAll, setIsSeeAll] = useState<boolean>(false);

    const fetchImages = useCallback(async (noItems: number, createdBy: string, isSeeAll: boolean) => {
        setIsLoading(true);
        const result = await fetchVectorizationBatches(noItems, createdBy, isSeeAll);
        setVectorizationBatchImages(result);
        setIsLoading(false);
    }, []);

    useEffect(() => {
        fetchImages(noItems, createdBy, isSeeAll);
    }, []);

    return (
        <PageLayout>
            <PageHeader
                title="Image Vectorization"
                isDisplayBack={false}
                t={t}
                right={
                    <ImageVectorizationFilter
                        t={t}
                        noItems={noItems}
                        onApplyFilter={() => fetchImages(noItems, createdBy, isSeeAll)}
                        isLoading={isLoading}
                        setNoItems={setNoItems}
                        setCreatedBy={setCreatedBy}
                        createdBy={createdBy}
                        isSeeAll={isSeeAll}
                        setIsSeeAll={setIsSeeAll}
                    />
                }
            />
            <PageBody isLoading={isLoading} t={t}>
                <div className="p-3 mb-3">
                    {(!vectorizationBatchImages || Object.keys(vectorizationBatchImages).length === 0) ? (
                        <EmptyState message={t("Filter.resultsNotFound")} />
                    ) : (
                        <div className="d-flex flex-column gap-3 justify-content-center">
                            {Object.keys(vectorizationBatchImages).map((batchId: string) => (
                                <VectorizationBatch key={batchId} vectorizationBatchImages={vectorizationBatchImages[batchId]} />
                            ))}
                        </div>
                    )}
                </div>
            </PageBody>
        </PageLayout>
    );
};

export default ImageVectorizationPage;
